import { z } from 'zod';
export const AI_PROVIDERS = ['openai', 'azure', 'gemini', 'custom'];
export const AI_TIERS = ['free', 'pro'];
export const aiSettingsSchema = z.object({
    provider: z.enum(AI_PROVIDERS),
    apiKey: z.string().min(1, 'API key is required'),
    endpoint: z.string().url('Must be a valid URL').optional(),
    deployment: z.string().optional(),
    apiVersion: z.string().optional(),
    model: z.string().optional(),
});
//# sourceMappingURL=aiSettings.js.map